const menuYenAnh = [
  {
    icon: "list-round",
    text: "Quản lý đơn hàng",
    subMenu: [
      {
        text: "Đơn phí khác",
        link: "/bill-other",
      },
      {
        text: "Đơn phí khác cần duyệt",
        link: "/bill-other-must-request",
      },
    ],
  },

  {
    icon: "ticket",
    text: "Quản lý thuế",
    subMenu: [
      {
        text: "Thuế",
        link: "/tax",
      },
      {
        text: "Báo cáo Thuế",
        link: "/tax-report",
      },
    ],
  },
  {
    icon: "user-list",
    text: "Quản lý nhân viên",
    subMenu: [
      {
        text: "Lương tháng",
        link: "/salary-per-month",
      },
    ],
  },
];
export default menuYenAnh;
